import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = loc.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        // Backend sets HttpOnly cookie; also persist token for Bearer fallback
        if (data.session_token) localStorage.setItem("nfl_bet_token", data.session_token);
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        nav("/login", { replace: true });
      }
    })();
  }, [loc.hash, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0D14] text-slate-300">
      <div className="text-center">
        <div className="animate-pulse text-sm uppercase tracking-widest">Authenticating...</div>
      </div>
    </div>
  );
}
